import { fetch } from '@atlassian/eoc-fetch';

export const fetchDownloadLinkEndpoint = async (exportUniqueKey: string) => {
	return fetch<string>(`/v1/logs/export/${exportUniqueKey}/download`, {
		responseType: 'text',
	});
};
